import { LitElement, html, css, utils } from '@hh/global.js';
const { debounce } = utils

class HHStickyFilter extends LitElement {
  static properties = {
    sticky: {
      type: Boolean,
      reflect: true,
    },
    endStickySelector: {
      type: String,
      attribute: 'end-sticky-selector',
    },
  }

  constructor() {
    super()
    this.calcPosition()

    this.debounceOnScroll = debounce(this.onScroll.bind(this), 0)
  }

  get header() {
    return document.querySelector('.js-header') ?? null
  }

  get announcementBar() {
    return document.querySelector('.js-announcement-bar-section') ?? null
  }

  get endStickyContainer() {
    return document.querySelector(this.endStickySelector) ?? null
  }

  connectedCallback() {
    super.connectedCallback()

    window.addEventListener('scroll', this.debounceOnScroll.bind(this))
    window.addEventListener('resize', this.onResize.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    window.removeEventListener('scroll', this.debounceOnScroll)
    window.addEventListener('resize', this.onResize)
  }

  firstUpdated() {
    this.calcPosition()
  }

  updateHeaderHeight() {
    return new Promise((resolve) => {
      this.headerHeight = this.header.offsetHeight
      this.announcementBarHeight = this.announcementBar?.offsetHeight || 0
      this.totalHeaderHeight = this.headerHeight + this.announcementBarHeight

      HH.setCSSVariable(
        '--hh-total-header-height',
        `${this.totalHeaderHeight}px`
      )
      resolve()
    })
  }

  calcPosition() {
    this.boundingRect = this.getBoundingClientRect()
    this.distanceFromTop = this.boundingRect.top + window.scrollY
    this.style.setProperty('--hh-sticky-left', `${this.boundingRect.left}px`)
  }

  async onScroll() {
    await this.updateHeaderHeight()

    if (this.endStickyContainer) {
      this.endStickyBoundingRect =
        this.endStickyContainer.getBoundingClientRect()
      this.endStickyDistanceFromTop =
        this.endStickyBoundingRect.bottom -
        this.boundingRect.height +
        window.scrollY

      this.sticky =
        window.scrollY > this.distanceFromTop &&
        window.scrollY < this.endStickyDistanceFromTop
    } else {
      this.sticky = window.scrollY > this.distanceFromTop
    }
  }

  onResize() {
    setTimeout(() => {
      this.calcPosition()
    }, 500)
  }

  render() {
    return html`<slot></slot>`
  }

  static styles = css`
    :host([sticky]) {
      position: fixed;
      top: 0;
      padding-top: 2rem;
      left: var(--hh-sticky-left);
      z-index: 50;
      transition: top var(--hh-duration-default) ease-in-out;
    }
  `
}

customElements.define('hh-sticky-filter', HHStickyFilter)
